/* Zapp carousel: scroll-snap track with prev/next arrows. Used by the UGC
   carousel and the reasons carousel. */
class ZappCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.prev = this.querySelector('[data-carousel-prev]');
    this.next = this.querySelector('[data-carousel-next]');
    if (!this.track) return;

    if (this.prev) this.prev.addEventListener('click', () => this.scrollBy(-1));
    if (this.next) this.next.addEventListener('click', () => this.scrollBy(1));

    this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
    window.addEventListener('resize', () => this.updateArrows(), { passive: true });
    this.updateArrows();
  }

  cardWidth() {
    var card = this.track.querySelector(':scope > *');
    if (!card) return this.track.clientWidth;
    var gap = parseFloat(getComputedStyle(this.track).columnGap || '16') || 16;
    return card.getBoundingClientRect().width + gap;
  }

  scrollBy(direction) {
    this.track.scrollBy({ left: direction * this.cardWidth(), behavior: 'smooth' });
  }

  updateArrows() {
    var max = this.track.scrollWidth - this.track.clientWidth - 4;
    if (this.prev) this.prev.toggleAttribute('disabled', this.track.scrollLeft <= 4);
    if (this.next) this.next.toggleAttribute('disabled', this.track.scrollLeft >= max);
  }
}

if (!customElements.get('zapp-carousel')) {
  customElements.define('zapp-carousel', ZappCarousel);
}
